import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import EnableSubscriptionComponent from '../components/enable-subscription/enable-subscription.component';
import PageLoader from '../../../../../components/PageLoader';
import { useAppDispatch } from '../../../../../hooks/hooks';
import { selectprogramsListItems, selectprogramsQueryItems } from '../../../../../redux/programs/selector';
import { programs } from '../../../../../redux/programs/action';
import { subscriptions } from '../../../../../redux/subscriptions/action';


const EnableSubscription = () => {
      const navigate = useNavigate()
      const dispatch = useAppDispatch()
      const {  CompanyName } = useParams()
      const [isLoading, setIsLoading] = useState<boolean>(true)
      const programItems = useSelector(selectprogramsListItems);
      const programQueryItems = useSelector(selectprogramsQueryItems);
       const [programData, setProgramData] = useState({
          OwnerName: '',
          Name: '',
          Description: '',
          Amount: 0,
          Validity: '',
          DBaaSProgram: [
            {
              Price: 0,
              ProgramDuration: '',
            },
          ],
        });
  const [
    enableSubscription,
    setEnableSubscription
  ] = useState<any>({})
 useEffect(() => {
    if (programQueryItems?.result) {
      setProgramData(programQueryItems.result.items);
    }
  }, [programQueryItems]);

  const handleOwnerIdChange = async (ownerId: string) => {
    await dispatch(
      programs.query({
        url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/programs/query`,
        entity: 'programs',
        jsonData: {
          Records: [{ Id: ownerId }],
        },
      })
    );
  };
  const handleInnerFormChange: any = (event: any, field: string) => {
    if (field === 'OwnerId') {
      handleOwnerIdChange(event);
      setEnableSubscription({ ...enableSubscription, [field]: event });
    } else {
      setEnableSubscription({ ...enableSubscription, [field]: event });
    }
  }

  useEffect(
    () => {
      dispatch(
           programs.list({
             url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/programs/list`,
             entity: 'programs',
             jsonData: {},
           })
         )
        setIsLoading(false)
    },
    []
  )
 
  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
      await dispatch(subscriptions.create({
        url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/subscriptions/enable`, entity: 'subscriptions', jsonData: {

          Records: [{
            "OwnerName": programData?.Name,
            "OwnerType": 'DBaasProgramPolicy',
            "OwnerId": enableSubscription?.OwnerId,
            "Name":  programData?.Name,
            "Description": programData?.Description,
            "Amount": programData?.DBaaSProgram[0]?.Price,
            "Validity": programData?.DBaaSProgram[0]?.ProgramDuration,
            "BusinessName": CompanyName
        }]
        }
      }))
    back()
  }

  const back=()=>{
    navigate('/management/platform-management/tenants')
  }
  return (
    <>
      {isLoading ? <PageLoader /> :
        <EnableSubscriptionComponent
          programs={programItems?.result?.items}
          handleInnerFormChange={handleInnerFormChange}
          back={back}
          handleFormSubmit={handleFormSubmit}
          enableSubscription={enableSubscription}
        />
      }
    </>
  )

}

export default EnableSubscription;